export const BASE_URL = "https://be-fixel.onrender.com/api/"; // lay tu .env
export const GET_JOBS = BASE_URL + "job";
export const GET_JOB_DETAIL = BASE_URL + "job/all-information";
export const GET_JOB_OFFER = BASE_URL + "job/offers-by-job";
export const GET_JOB_PAYMENT = BASE_URL + "job/payments-by-job";
